module.exports = __webpack_public_path__ + "static/media/Xlsx.0dfb17e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/Xlsx.svg
// module id = 1686
// module chunks = 17